import { createReducer, INITIAL_STATE } from '../../../shared/redux';

export const INTEGRATION_SET_LOADING = '@integrations/list/SET-LOADING';

export const GET_ACTIVE_INTEGRATIONS_REQUEST_CALLED = '@integrations/list/GET_ACTIVE_INTEGRATIONS_REQUEST_CALLED';
export const GET_ACTIVE_INTEGRATIONS_REQUEST_SUCCESS = '@integrations/list/GET_ACTIVE_INTEGRATIONS_REQUEST_SUCCESS';
export const GET_ACTIVE_INTEGRATIONS_REQUEST_FAIL = '@integrations/list/GET_ACTIVE_INTEGRATIONS_REQUEST_FAIL';

export type IntegrationsState = {
  loading: boolean
  activeIntegrations: { [integrationName: string]: boolean }
}

export const initialState: IntegrationsState = {
    loading: true,
    activeIntegrations: {},
};

export const getIntegrationsListState = (state): IntegrationsState => ({
    ...state.integrations.list,
});

export const setLoading = (isLoading: boolean) => ({
    type: INTEGRATION_SET_LOADING,
    payload: {
        loading: isLoading,
    },
});

export const getActiveIntegrationsAction = (clientId: number) => ({
    type: GET_ACTIVE_INTEGRATIONS_REQUEST_CALLED,
    actionTypes: {
        success: GET_ACTIVE_INTEGRATIONS_REQUEST_SUCCESS,
        fail: GET_ACTIVE_INTEGRATIONS_REQUEST_FAIL,
    },
    config: {
        url: '/api/active-integrations',
        method: 'GET',
        params: {
            client_id: clientId,
        },
    },
});

export const integrationsListReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [INTEGRATION_SET_LOADING]: (state, action) => ({
        ...state,
        loading: action.payload.loading,
    }),
    [GET_ACTIVE_INTEGRATIONS_REQUEST_CALLED]: state => ({
        ...state,
        loading: true,
    }),
    [GET_ACTIVE_INTEGRATIONS_REQUEST_SUCCESS]: (state, action) => ({
        ...state,
        loading: false,
        activeIntegrations: action.payload.data,
    }),
});
